module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/layout/header/navsearch/navsearch.component.scss
// module id = ./src/app/layout/header/navsearch/navsearch.component.scss
// module chunks = main